import { render } from "./FacebookLink.vue?vue&type=template&id=0f27e95e&scoped=true"
import script from "./FacebookLink.vue?vue&type=script&lang=js"
export * from "./FacebookLink.vue?vue&type=script&lang=js"

import "./FacebookLink.vue?vue&type=style&index=0&id=0f27e95e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f27e95e"]])

export default __exports__